import React from 'react';
import ListPageHeader from '@shared/ListPageHeader';
import AiAuditLogList from '@shared/ai/AiAuditLogList';
import aiAuditLogService from '@services/operator/aiAuditLogService';

export default function OperatorAiAuditLogsList() {
  return (
    <div>
      <ListPageHeader items={['api_integration', 'api_integration.ai_audit_logs']} />
      <AiAuditLogList service={aiAuditLogService} />
    </div>
  );
}
